import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importation des fichiers de traduction
import enTranslation from "./locales/en.json";
import frTranslation from "./locales/fr.json";

// Initialisation de i18next
i18n
  .use(initReactI18next) // Intégration avec React
  .init({
    resources: {
      en: { translation: enTranslation },
      fr: { translation: frTranslation },
    },
    fallbackLng: "fr", // Langue par défaut si la langue préférée n'est pas trouvée
    interpolation: {
      escapeValue: false, // React gère l'échappement
    },
    detection: {
      order: ["navigator", "cookie", "localStorage", "querystring"], // Priorité pour détecter la langue
      caches: ["cookie"], // Stocker la langue préférée dans un cookie
    },
  });

export default i18n;
